import React,{ useEffect, useState} from 'react';

import DataTableDoc from '../../components/datatable/DataTableDoc';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';



const  DocumentDatatable = (props) => {

   const [t] = useTranslation();      
   const [entitySubName, setEntitySubName] = useState();
   const [entitySpecify, setEntitySpecify] = useState();
   const [checkTime, setCheckTime] = useState();
  


   const tableName = props.showSelectEntitySpecify ? t('document.label.'+props.entitySubName+'s') : '';
   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('document.label.type'), data: "entitySpecify", sortable: true, selector: "entitySpecify"},    		
            { name: t('document.label.created'), data: "creationDate",  sortable: true,  selector: "creationDate"},
            { name: t('document.label.effectiveDate'), data: "effectiveDate",  sortable: true,  selector: "effectiveDate"},
            { name: t('document.label.documentNbr'), data: "documentNbr", sortable: true,  selector: "documentNbr"},
            { name: t('document.label.accountingCode'), data: "accoutingCode", sortable: true,  selector: "accoutingCode"},            
            { name: t('partner.label.partner'), data: "partnerAddress.name", sortable: true,  selector: "partnerAddress.name"},
            { name: t('document.label.totalExcludeVat'), data: "totalExcludeVat", sortable: true,  selector: "totalExcludeVat"},
            { name: t('document.label.totalIncludeVat'), data: "totalIncludeVat", sortable: true,  selector: "totalIncludeVat"},
            
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('document.label.type'), data: "entitySpecify",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('document.label.created'), data: "creationDate", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('document.label.effectiveDate'), data: "effectiveDate", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('document.label.documentNbr'), data: "documentNbr", orderable: true,  searchable: true, search: {value: '',regex: false}},     
        { name: t('document.label.accountingCode'), data: "accoutingCode", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('partner.label.partner'), data: "partnerAddress.name", orderable: true,  searchable: true, search: {value: '',regex: false}},     
        { name: t('document.label.totalExcludeVat'), data: "totalExcludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('document.label.totalIncludeVat'), data: "totalIncludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},
    ];        


    const columnsSubRow = [       
      { name: t('document.label.item'),  data: "itemName", selector: "itemName", minWidth: '300px'},   
      { name: t('document.label.qty'),  data: "qty", selector: "qty"},
      { name: t('document.label.um'),  data: "um", selector: "um"},
      { name: t('document.label.vat'),  data: "vat", selector: "vat"},
      { name: t('document.label.priceExcludeVat'),  data: "unitPriceExcludeVat", selector: "unitPriceExcludeVat"},
      { name: t('document.label.priceIncludeVat'),  data: "unitPriceIncludeVat", selector: "unitPriceIncludeVat"},
      { name: t('document.label.totalExcludeVat'),  data: "totalPriceExcludeVat", selector: "totalPriceExcludeVat"},
      { name: t('document.label.totalIncludeVat'),  data: "totalPriceIncludeVat", selector: "totalPriceIncludeVat"},
      { name: t('document.label.note'),  data: "note", selector: "note"},
      { name: t('document.label.internalNote'),  data: "internalNote", selector: "internalNote"}
    
  ];    

    const url = RestService.getBaseURL()+"document/getList?entitySubName="+props.entitySubName; //+"&entitySpecify="+props.entitySpecify;  
    const urlExcel = RestService.getBaseURL()+"document/getListExcel?entitySubName="+props.entitySubName; //+"&entitySpecify="+props.entitySpecify;          
 
  

    const handleCallback  = (id,subRowId) => {
            props.parentCallback(id,subRowId);                   
    };

   

    const handleEntitySpecify  = (entitySpecify) => {
        setEntitySpecify(entitySpecify);  
        props.parentCallbackEntitySpecify(entitySpecify);
    };
  
  
     useEffect(() => {      
        setEntitySubName(props.entitySubName);  
      }, [props.entitySubName])

      useEffect(() => {      
        setEntitySpecify(props.entitySpecify);  
      }, [props.entitySpecify])
       

      useEffect(() => {      
        setCheckTime(props.checkTime);
      }, [props.checkTime])
       
      
        return (
            
            <DataTableDoc
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                columnsSubRow={columnsSubRow}
                parentCallback={handleCallback}
                parentCallbackEntitySpecify={handleEntitySpecify}               
                entitySubName={entitySubName}
                entitySpecify={entitySpecify}
                checkTime={checkTime}
                showSelectEntitySpecify={props.showSelectEntitySpecify}    
                exportShow={true}
                              
            />
           /* <DataTable              
                parentCallback={handleCallback.bind(this)}
                ref={dataTableRef}               
                aoColumns={aoColumns}               
                url={url}                                
            />
           */
          
        );
   

 
};


export default DocumentDatatable;

